import { render, staticRenderFns } from "./NewWorkLoadOpp.vue?vue&type=template&id=1a052376&scoped=true&"
import script from "./NewWorkLoadOpp.vue?vue&type=script&lang=js&"
export * from "./NewWorkLoadOpp.vue?vue&type=script&lang=js&"
import style0 from "./NewWorkLoadOpp.vue?vue&type=style&index=0&id=1a052376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a052376",
  null
  
)

export default component.exports